import {
  AssignLicenseForm,
  VoiceControlsList,
  VoiceControlsStatusMessage,
} from ".";
import { Suspense, useEffect } from "react";
import {
  getSelectedDeviceData,
  refreshDeviceStatus,
} from "../../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import cn from "classnames";
import { loadTestComponent } from "../../utils";
import styles from "./VoiceControlsContainer.module.scss";

export function VoiceControlsContainer({ className }) {
  const dispatch = useDispatch();
  const deviceSelected = useSelector(getSelectedDeviceData);

  useEffect(() => {
    if (deviceSelected.status === "") {
      dispatch(refreshDeviceStatus(deviceSelected.cloudId));
    }
  }, [deviceSelected, dispatch]);

  const contentByDeviceStatus = {
    ok: <VoiceControlsList />,
    available: <AssignLicenseForm />,
  };

  const TestingWrapper = loadTestComponent(
    () => import("../../components/test/TestingWrapper")
  );

  const VoiceControlTestSections = loadTestComponent(
    () => import("../../components/test/VoiceControlTestSections")
  );

  return (
    <div className={cn(styles.voiceControlsContainer, className)}>
      <Suspense fallback={<></>}>
        <TestingWrapper>
          <VoiceControlTestSections />
        </TestingWrapper>
      </Suspense>
      {contentByDeviceStatus[deviceSelected.status] || (
        <VoiceControlsStatusMessage />
      )}
    </div>
  );
}
